import CryptoJS from 'crypto-js/crypto-js'

// 配置API接口地址
//var root = 'http://track.iquickfish.com/v1';
var root = '/v1';

// 配置API接口地址
var root1 = "http://localhost:58427/api";//测试本地，用CORS跨域
//var root = "/api/";//用proxy实现本地代理跨域（生产环境使用的是nginx）

// 引用axios
var axios = require('axios')
// 自定义判断元素类型JS
function toType (obj) {
  return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase()
}
// 参数过滤函数
function filterNull (o) {
  for (var key in o) {
    if (o[key] === null) {
      delete o[key]
    }
    if (toType(o[key]) === 'string') {
      o[key] = o[key].trim()
    } else if (toType(o[key]) === 'object') {
      o[key] = filterNull(o[key])
    } else if (toType(o[key]) === 'array') {
      o[key] = filterNull(o[key])
    }
  }
  return o
}
/*
  接口处理函数
  这个函数每个项目都是不一样的，我现在调整的是适用于
  https://cnodejs.org/api/v1 的接口，如果是其他接口
  需要根据接口的参数进行调整。参考说明文档地址：
  https://cnodejs.org/topic/5378720ed6e2d16149fa16bd
  主要是，不同的接口的成功标识和失败提示是不一致的。
  另外，不同的项目的处理方法也是不一致的，这里出错就是简单的alert
*/

function apiAxios (method, url, params, success, failure) {
  if (params) {
    params = filterNull(params)
  }
  var headObj=getHeaderData();
  axios({
    method: method,
    url: url,
    data: method === 'POST' || method === 'PUT' ? params : null,
    params: method === 'GET' || method === 'DELETE' ? params : null,
　　 //headers 是即将被发送的自定义请求头，还记得我们的jwt验证么，可以封装进来，注意!这里如果要添加 headers ，一定要是正确的值
　　 //headers:{"Authorization":"Bearer xxxxxxx"},
    headers:headObj,
    baseURL: root,
    withCredentials: false
  })
    .then(function (res) {
      debugger
      //if (res.data.success === true) {
      if (res.data) {
        if (success) {
          success(res.data)
          //success(res)
        }
      } else {
        if (failure) {
          failure(res.data)
        } else {
          window.alert('error: ' + JSON.stringify(res.data))
        }
      }
    }
    )
    .catch(function (err) {
      let res = err.response
      if (err) {
        //window.alert('api error, HTTP CODE: ' + res.status)
        window.alert(err)
        //window.alert('api error, HTTP CODE: ' + JSON.stringify(res.data))
      }
    })
}

// function getHeaderData2(){
// var userId=10000;
// var apiKey="8144de36-1055-4d39-b26a-9e08798c4bad";

// var nowDate = new Date();
// var month = nowDate.getMonth() + 1;
// if (month >= 1 && month <= 9) {
//     month = "0" + month;
// }
// var day = nowDate.getDate();
// if(day >= 0 && day <= 9) {
//         day = "0" + day;
//     }
    
// var hour=nowDate.getHours();
// hour=(hour<10?"0":"")+hour;

// var minute=nowDate.getMinutes();
// minute=(minute<10?"0":"")+minute;


// var second=nowDate.getSeconds();
// second=(second<10?"0":"")+second;

// var timeStr=nowDate.getFullYear().toString()+month+day+hour+minute+second;
// console.log(timeStr);
// var kfy_userid=userId+"_"+timeStr;// （格式：yyyyMMddHHmmss）
// var kfy_signdata=CryptoJS.MD5(kfy_userid+apiKey).toString();//(kfy_userid+APIKey) //(取MD5值，32位小写)
// console.log(kfy_signdata);
// var headObj={
//     "kfy_userid":kfy_userid,
//     "kfy_signdata":kfy_signdata
// };
// return headObj;
// }


function getHeaderData(){
  var timeStamp = Date.parse( new Date())/1000;//精确到秒
  var headObj={
      "timeStamp":timeStamp
  };
  return headObj;
  }

// 返回在vue模板中的调用接口
export default {
    get: function (url, params, success, failure) {
      return apiAxios('GET', url, params, success, failure)
    },
    post: function (url, params, success, failure) {
      return apiAxios('POST', url, params, success, failure)
    },
    put: function (url, params, success, failure) {
      return apiAxios('PUT', url, params, success, failure)
    },
    delete: function (url, params, success, failure) {
      return apiAxios('DELETE', url, params, success, failure)
    }
  }

